import { render, staticRenderFns } from "./PrivacyProtectConceptContentItem.vue?vue&type=template&id=3056fdbd&scoped=true&"
import script from "./PrivacyProtectConceptContentItem.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtectConceptContentItem.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyProtectConceptContentItem.vue?vue&type=style&index=0&id=3056fdbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056fdbd",
  null
  
)

export default component.exports